export default "__VITE_ASSET__BETk_Y3___"